// Editorial team configuration for Finance Topia.
// Update the fields below with your real credentials once you're ready.
// Everything referenced from ArticlePage / AuthorPage / About page reads from here.
//
// AdSense / E-E-A-T tip: for YMYL (finance) content, Google rewards sites
// that show real people with verifiable credentials (LinkedIn, CFA number,
// authored publications). Swap the placeholder identity below for yours to
// dramatically improve your E-E-A-T signal.

export const EDITORIAL_ORG = {
  name: "Finance Topia Editorial Desk",
  slug: "editorial-desk",
  role: "Editorial Team",
  short_bio:
    "Independent editorial team covering markets, personal finance, and investing.",
  full_bio:
    "The Finance Topia editorial team publishes fact-based, beginner-friendly analysis of finance and markets. Every article is drafted with AI-assisted research and reviewed against our editorial standards before publication.",
  credentials: [
    "Editorial oversight modeled on CFA Institute standards of practice",
    "Cites primary sources (Federal Reserve, BLS, IMF, SEC) wherever possible",
    "No sponsored content, no paid guest posts, no affiliate rewrites",
  ],
  photo: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&q=85&auto=format&fit=crop",
  photo_alt: "Finance Topia editorial desk workspace",
  linkedin: "",  // e.g. "https://linkedin.com/company/finance-topia"
  twitter: "",
  email: "editorial@finance-topia.com",
};

// Displayed on each article's byline. Update to a real editor's name to
// strengthen E-E-A-T and AdSense credibility.
export const DEFAULT_AUTHOR_NAME = "Finance Topia Editorial Desk";
